export const LABELS_MAP = {
  federalTaxCredit: 'Tax Credit',
  insurance: 'Insurance',
  maintenance: 'Maintenance',
  repairs: 'Repairs',
  taxesAndFees: 'Taxes & Fees',
  financeInterest: 'Financing',
  depreciation: 'Depreciation',
  fuel: 'Fuel',
  tcoPrice: 'True Cost to Own®',
  // averageCostPerMile: 'Cost Per Mile',
};
